import {
  Box,
  Button,
  Flex,
  HStack,
  TableContainer,
  useDisclosure,
  Text,
  Table,
  Th,
  Tbody,
  Tr,
  Td,
  VStack,
  Avatar,
  Icon,
  Spinner,
  Thead,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  Center,
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import Header from '../../../components/header/Header';
import SearchBar from '../../../components/searchbar/SearchBar';
import moment from 'moment';
import { mutateFunction, useMutation } from '../../../libs/apis';
import { CustomToast } from '../../../components/toast/CustomToast';
import { useData } from '../../../data';
import IsDesktop from '../../../utils/IsDesktop';
import ViewUserDetails from './ViewUserDetails';
import UserCountSection from './UsersCountSection';
import { BsDownload } from 'react-icons/bs';
import exportToCSV from '../../../utils/ExportToCSV';
import BrandButton from '../../../components/brandButton/BrandButton';
import { CheckIcon, CloseIcon } from '@chakra-ui/icons';
import SubAdminForm from './subAdminForm';
import { useSelector } from 'react-redux';
import PermissionBlinder from '../../../components/PermissionBlinder';

const permissions = [
  { key: 'can_manage_dashboard', label: 'Dashboard' },
  { key: 'can_manage_users', label: 'Users' },
  { key: 'can_manage_offers', label: 'Offers' },
  { key: 'can_manage_brands', label: 'Brands' },
  { key: 'can_manage_subscriptions', label: 'Subscriptions' },
  { key: 'can_manage_deleted_users', label: 'Deleted Users' },
  { key: 'can_manage_post_reports', label: 'Post Reports' },
  { key: 'can_manage_adverts', label: 'Adverts' },
  { key: 'can_manage_deals', label: 'Deals' },
  { key: 'can_manage_news', label: 'News' },
  { key: 'can_manage_pitch_requests', label: 'Pitch Requests' },
  { key: 'can_manage_subscription_plans', label: 'Subscription Plans' },
];

const SubAdmins = () => {
  const { data, isLoading, refetch } = useData('subadmins');
  const [displayedListStatus, setDisplayedListStatus] = useState('all');
  const [displayedList, setDisplayedList] = useState([]);
  const [selecteduser, setSelectedUser] = useState();
  const { mutate, isLoading: isLoadingMutation } = useMutation(mutateFunction);
  const { addToast } = CustomToast();
  const isDesktop = IsDesktop();
  const {
    isOpen,
    onClose,
    onToggle
  } = useDisclosure()
  const {
    isOpen: deleteAdminIsOpen,
    onClose: onCloseDeleteAdmin,
    onToggle: onToggleDeleteAdmin
  } = useDisclosure()

  const _permissions = useSelector(
    (state) => state?.user?.userInfo?.permissions,
  );

  const changeUserView = (advertStatus) => {
    setDisplayedListStatus(advertStatus);
  };
  const viewUser = (user) => {
    setSelectedUser(user);
    onToggle()
    // onToggleUserDetails();
  };

  const downloadCSV = () => {
    const __data = displayedList.map((item) => {
      return [
        `${item.firstName} ${item.lastName}`,
        item.email,
        item.firstName === item.initiator ? 'Self' : item.initiator,
        moment(item.createdAt).format('DD/MM/YYYY [at] HH:mm'),
        item.confirmedAt
          ? moment(item.confirmedAt).format('DD/MM/YYYY [at] HH:mm')
          : '',
      ];
    });

    __data.unshift([
      'Profile',
      'Email',
      'Initiated By',
      'Initiated At',
      'Confirmed At',
    ]);

    exportToCSV(__data, 'seedafounder_deleted_users.csv');
  };

  const onEdit = () => {

  }

  const onDelete = (user) => {
    setSelectedUser(user);
    onToggleDeleteAdmin()
  }

  useEffect(() => {
    if (data?.data) {
      setDisplayedList(data?.data?.admins);
    }
  }, [data, displayedListStatus]);

  const onSubmitSuccess = () => {
    onClose()
    refetch()
    setSelectedUser(null)
  }

  const deleteAdmin = async (e) => {
    try {
      e.preventDefault()
      if (isLoading || isLoadingMutation) return
      const url = `subadmins/${selecteduser.user_id}`;
      const method = 'DELETE'
      mutate(
        {
          key: url,
          method,
          data: {},
        },
        {
          onSuccess(res) {
            addToast(res);
            refetch()
            onCloseDeleteAdmin()
            setSelectedUser(null)
          },
          onError(e) {
            addToast({ message: `Sub admin was not deleted, ${e || ''}` }, 'error');
          },
        },
      );
    } catch (err) {
      console.error(err);
      addToast({ message: `Could not delete sub admin` }, 'error');
    }
  };

  if (_permissions) {
    return <PermissionBlinder />
  }
  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} size="xl">
        <ModalOverlay />
        <ModalContent>
          <ModalBody p={4}>
            <Flex flexDirection="column">
              <SubAdminForm onClose={onClose} onSubmitSuccess={onSubmitSuccess} subAdmin={selecteduser} />
            </Flex>
          </ModalBody>
        </ModalContent>
      </Modal>
      <Modal isCentered isOpen={deleteAdminIsOpen} onClose={onCloseDeleteAdmin}>
        <ModalOverlay />
        <ModalContent p={"16px"} maxW={350}>
          <ModalBody p={0}>
            <Center d="flex" flexDirection="column" className="gap-2" >
              <Text textAlign={"center"} fontWeight={500} fontSize={19} color="#000">
                Are you sure you want to remove, {selecteduser?.user?.first_name}, as an admin?
              </Text>
              <Flex className="gap-2 w-full">

                <BrandButton
                  isLoading={isLoadingMutation}
                  fontSize="13px" py={2}
                  color="#F2112D"
                  borderColor="#F2112D"
                  bg="#FFF"
                  _hover={{ backgroundColor: "red.50" }}
                  height="36px"
                  mt={6}
                  text={`Yes`}
                  width="full"
                  onClick={deleteAdmin}

                />
                <BrandButton
                  fontSize="13px" bg="#20B962" py={2}
                  height="36px"
                  colorScheme="blue"
                  onClick={onCloseDeleteAdmin}
                  mt={6}
                  text="No"
                  width="full"
                />
              </Flex>
            </Center>
          </ModalBody>
        </ModalContent>
      </Modal>
      <Box>
        <Header title="Sub Admins" />
        {/* {isOpen && (
          <ViewUserDetails user={selecteduser} onToggle={onToggleUserDetails} />
        )} */}
        {true && (
          <>
            <Flex w="100%">
              <Box mt="20px" w="100%">
                <HStack
                  w="100%"
                  justifyContent="space-between"
                  className="items-start flex-wrap gap-2 px-3 max-w-screen-2xl"
                >
                  <UserCountSection
                    totalUsers={data?.data?.admins?.length}
                  />
                  {/* <BrandButton
                    text="Download CSV"
                    minW="140px"
                    onClick={downloadCSV}
                  /> */}
                </HStack>

                {/* <Flex w="100%" justify="space-between" alignItems="center">
                  <SearchBar
                    searchType="deleted-user"
                    searchRoute="admins/search-deletion-request"
                    onSelectOption={(advert) => {
                      viewUser(advert);
                    }}
                  />
                </Flex> */}

                <Box className='flex w-full p-3 justify-end'>
                  <BrandButton
                    text="Create SubAdmin"
                    minW="180px"
                    onClick={onToggle}
                  />
                </Box>
              </Box>
            </Flex>
            <Box
              className={`flex-col w-full overflow-x-auto hide-scroll ${isDesktop
                ? 'max-h-[75vh] fixed mt-5 px-2 pb-32 overflow-y-scroll'
                : ''
                }`}
            >
              <Box overflowX="auto">
                <TableContainer
                  mt="50px"
                  borderRadius="10px"
                  overflowX="auto"
                  className='w-[80%] xl:w-[85%] hide-scroll'
                >
                  <Table
                    variant="simple"
                    size="sm"
                    fontSize="12px"
                    w={['100%']}
                    minWidth="900px"
                  >
                    <Thead>
                      <Tr>
                        <Th>Name</Th>
                        <Th>Email</Th>
                        {permissions.map((perm) => (
                          <Th key={perm.key} textAlign="center">
                            {perm.label}
                          </Th>
                        ))}
                        <Th>Actions</Th>
                      </Tr>
                    </Thead>
                    {!isLoading ? (
                      <Tbody>
                        {displayedList.map((admin) => (
                          <Tr className={`cursor-pointer`} key={admin.id}>
                            <Td>{`${admin.user?.first_name} ${admin.user?.last_name}`}</Td>
                            <Td>{admin.user?.email}</Td>
                            {permissions.map((perm) => (
                              <Td key={perm.key} textAlign="center">
                                {admin[perm.key] ? (
                                  <Icon as={CheckIcon} color="green.500" />
                                ) : (
                                  <Icon as={CloseIcon} color="red.500" />
                                )}
                              </Td>
                            ))}
                            <Td>
                              <Button
                                size="xs"
                                colorScheme="blue"
                                mr={2}
                                onClick={() => viewUser(admin)}
                              >
                                Edit
                              </Button>
                              <Button
                                size="xs"
                                colorScheme="red"
                                onClick={(e) => {
                                  e.stopPropagation()
                                  onDelete(admin)
                                }
                                }
                              >
                                Delete
                              </Button>
                            </Td>
                          </Tr>
                        ))}
                      </Tbody>
                    ) : (
                      <Spinner m={5} />
                    )}
                  </Table>
                </TableContainer>
              </Box>
            </Box>
          </>
        )}
      </Box>
    </>
  );
};

export default SubAdmins;
